export default __webpack_public_path__ + "static/media/slider4it.a4c3281b.jpg";